<input 
    matInput
    [disabled]="readonly"
    class="outline" 
    [placeholder]="placeholderAmount" 
    (keydown.enter)="onEnter()" 
    (keydown.backspace)="onBackspace()"
    [class.outline]="outline" 
    [class.has-error]="hasError" 
    [(ngModel)]="displayAmount" 
    (ngModelChange)="change($event)" 
    (focus)="onFocus()" 
    (blur)="onBlur()">